module.exports = __webpack_public_path__ + "static/media/22.269e0f44.svg";